import { Fragment, ReactNode } from 'react';

import { AnyDynamicFormComponentRegistry, DynamicFormFieldConfig } from './field-registry';

export interface DynamicFormItemsRender<TRegistry extends AnyDynamicFormComponentRegistry>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  extends Function {
  (props: DynamicFormItemsRenderProps<TRegistry>): ReactNode;
}

export interface DynamicFormItemsRenderProps<TRegistry extends AnyDynamicFormComponentRegistry> {
  fields: readonly DynamicFormFieldConfig<TRegistry>[];
  itemRender: (item: DynamicFormFieldConfig<TRegistry>) => ReactNode;
}

export const defaultItemsRender: DynamicFormItemsRender<AnyDynamicFormComponentRegistry> = ({
  fields,
  itemRender,
}) => {
  return fields.map((field) => <Fragment key={field.name}>{itemRender(field)}</Fragment>);
};
